import { Sentry } from '@/components/Sentry';
import { NarrativeFairValue } from '@/components/NarrativeFairValue';

import { getTradingItemCurrencyISO } from '@/utilities/getTradingItemCurrencyISO';

import type { WatchlistItem } from '@/hooks/useWatchlist';

import { WatchlistNarrativeFairValueModal } from './WatchlistNarrativeFairValueModal';
import { getWatchlistNarrativeFairValue } from './utils';
import { useQueryStringParam } from '@/hooks/useQueryStringParam';
import { useToggleStateOnMatchQueryParam } from '@/hooks/useToggleStateOnMatchQueryParam';

export interface Props {
  watchlistId: string;
  watchlistItem: WatchlistItem;
}

export const WatchlistNarrativeFairValue = ({
  watchlistItem,
  watchlistId,
}: Props) => {
  const { company } = watchlistItem;
  const { setItem, getItem, removeItem } = useQueryStringParam();

  const {
    isToggleOn: isModalOpen,
    handleToggleOff,
    handleToggleOn,
  } = useToggleStateOnMatchQueryParam({
    matchesQueryParam: () => getItem('company') === company.id,
    setQueryParam: setItem,
    removeQueryParam: removeItem,
    queryParam: { key: 'company', value: company.id },
  });

  const narrativeFairValue = getWatchlistNarrativeFairValue({ watchlistItem });

  const companyCurrencyISO =
    getTradingItemCurrencyISO(company.data.currencyInfo) ?? 'XXX';

  if (!watchlistId) return null;

  return (
    <Sentry sentryCapture={{ team: 'narwhals' }} globalDisabled>
      <WatchlistNarrativeFairValueModal
        companyId={company.id}
        isOpen={isModalOpen}
        onClose={handleToggleOff}
      />

      <NarrativeFairValue
        currencyISO={companyCurrencyISO}
        narrativeFairValue={narrativeFairValue}
        npvPerShare={company.analysisValue?.npvPerShare ?? null}
        onClick={handleToggleOn}
      />
    </Sentry>
  );
};
